import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IConvert } from '../../../../models/evaluation.model'
import { doGetConverts, doUpdateConvert } from '../../../../store/convert.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import { useSnackbar } from 'notistack';
import qs from 'qs';

import Loader from '../../../../components/Loader';
import Header from '../../../../components/layout/Header';
import Footer from '../../../../components/layout/Footer';
import Editor from '../../../../components/program/convert/table/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../../lib/barVariant';
import SimpleHeader from '../../../../components/layout/SimpleHeader';

interface IMatch {
  topId: string;
  subId: string;
}

const ProgramConvertEdit: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.convert);
  
  const match = useRouteMatch<IMatch>();
  const topId = Number(match.params.topId);
  const subId = Number(match.params.subId);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const [convert, setConvert] = useState<any>();
  const [name, setName] = useState('');

  useEffect(() => {
    // query to state
    if (query.name) setName(String(query.name));
  }, [location]);

  useEffect(() => {
    getConvert();
  }, [])

  const getConvert = async () => {
    const res = await dispatch(doGetConverts(topId));

    switch (res?.status) {
      case 200:
        {
          const convert = res.data?.data?.find((item: IConvert) => item.conversionCode === subId);
          if (convert) setConvert(convert);
        }
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: IConvert) => {
    const res = await dispatch(doUpdateConvert(subId, req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/program/convert/${topId}/table?name=${name}`);
        break;
      case 400:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), warningVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={`${t('program.convert.message4')} - ${name}`}
      />
      <Editor
        convert={convert || null}
        onSubmit={onSubmit}
        id={topId}
        name={name}
      />
    </div>
  )
}

export default ProgramConvertEdit;
